import React from 'react';
import { Table, Radio, Tag } from 'antd';

const ActivityDevices = ({ 
  dataDeviceByProperty, 
  selectedDeviceId, 
  loading, 
  onDeviceSelect 
}) => {
  
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active': return 'success';
      case 'inactive': return 'default';
      case 'maintenance': return 'warning';
      default: return 'default';
    }
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 150,
    },
    {
      title: 'Type',
      key: 'type',
      width: 110,
      render: (_, device) => device.type_label || device.type || 'Device'
    },
    {
      title: 'Status',
      dataIndex: ['iot_device', 'status'],
      key: 'status',
      width: 120,
      render: (status, device) => {
        // A WhatsApp device has no supplier status to report, and showing
        // "N/A" next to a tracker's "Active" reads as a fault. Say what it
        // actually is: points arrive only when the worker sends them.
        if (device.type === 'whatsapp') {
          return (
            <Tag color="processing" style={{ borderRadius: '12px' }}>
              Shared points
            </Tag>
          );
        }

        return (
          <Tag 
            color={getStatusColor(status)}
            style={{ borderRadius: '12px' }}
          >
            {(status && (String(status[0]).toUpperCase() + String(status).slice(1))) || 'N/A'}
          </Tag>
        );
      }
    },
    {
      title: 'Active Device',
      key: 'action',
      width: 80,
      align: 'center',
      render: (_, device) => (
        <Radio
          value={device.history_id}
          checked={selectedDeviceId === device.history_id}
          disabled={loading && selectedDeviceId === device.history_id}
        />
      )
    }
  ];

  return (
    <div className="device-selection">
      <div className="device-table-container">
        <Radio.Group onChange={onDeviceSelect} value={selectedDeviceId}>
          <Table
            dataSource={dataDeviceByProperty}
            columns={columns}
            rowKey="id"
            size="small"
            pagination={false}
            scroll={{ y: 'calc(25vh - 60px)' }}
            rowClassName={(device) =>
              selectedDeviceId === device.history_id ? 'ant-table-row-selected' : ''
            }
          />
        </Radio.Group>
      </div>
    </div>
  );
};

export default ActivityDevices;